import { LogDetailsModal } from '@/shared/components/LogDetailsModal';
import React from 'react';
import type { ActivityLog } from '../../types';
import { formatInitiator, getStatusBadgeColor } from './utils';

type Props = {
  log: ActivityLog | null;
  visible: boolean;
  onClose: () => void;
};

export const ActivityLogDetailsModal: React.FC<Props> = ({ log, visible, onClose }) => {
  if (!log) return null;

  const jsonSections = [
    ...(log.details ? [{ title: 'Event Details', data: log.details }] : []),
    { title: 'Full Activity Log Data', data: log },
  ];

  return (
    <LogDetailsModal
      visible={visible}
      onClose={onClose}
      title="Activity Log Details"
      baseData={{
        id: log.id,
        createdAt: log.createdAt,
      }}
      additionalFields={[
        {
          label: 'Event',
          value: log.event,
        },
        {
          label: 'Category',
          value: log.category,
        },
        {
          label: 'Level',
          value: (
            <span className={`badge bg-${getStatusBadgeColor(log.level)} ms-2`}>{log.level}</span>
          ),
        },
        {
          label: 'Initiator',
          value: formatInitiator(log.actorType, log.userName),
        },
        {
          label: 'Customer ID',
          value: log.shopifyCustomerId.toString(),
        },
      ]}
      jsonSections={jsonSections}
    />
  );
};
